import React from "react";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";

const DefaultLayout = ({ children, header = true, footer = true }) => {
  return (
    <div>
      {header && <Header />}
      <main>{children}</main>
      {footer && <Footer />}
    </div>
  );
};

export default DefaultLayout;
